import React from 'react';
import PropTypes from 'prop-types';

import HtmlElement from '../HtmlElement';

const defaultProps = {
  href: '',
  children: null,
};

const propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};

const Link = ({
  href,
  children,
  ...rest
}) => (
  <HtmlElement
    href={href}
    tagName="a"
    {...rest}
  >
    {children}
  </HtmlElement>
);

Link.defaultProps = defaultProps;
Link.propTypes = propTypes;

export default Link;
